import { PureComponent } from "react";
import { styles } from "./picture-preview-component.scss";
import { fixDevImageUrl } from "/services/community/url-service";

export default class PicturePreviewComponent extends PureComponent {
  render() {
    let { src, closeCallback } = this.props;
    return (
      src && (
        <div className="preview-image-container" onClick={closeCallback}>
          <div className="container-with-close">
            <figure className="image-figure">
              <div className="header">
                <div className="close" />
              </div>
              <img className="preview-image" src={fixDevImageUrl(src)} onClick={closeCallback} />
            </figure>
          </div>
          <style jsx>{styles}</style>
        </div>
      )
    );
  }
}
